export function isOnLoginPage(): boolean {
  return window.location.pathname.startsWith("/login");
}

export function currentPageForLoginRedirect(): string | undefined {
  const here = window.location.pathname + window.location.search;
  if (here === "/" || isOnLoginPage()) return undefined;
  return here;
}

export function redirectToLogin(): void {
  if (isOnLoginPage()) return;
  const redirect = currentPageForLoginRedirect();
  window.location.href = redirect ? `/login?redirect=${encodeURIComponent(redirect)}` : "/login";
}

export function linkedAccountFrom(path: string): number | undefined {
  const value = new URL(path, window.location.origin).searchParams.get("account");
  const accountId = value === null ? NaN : Number(value);
  return Number.isInteger(accountId) && accountId > 0 ? accountId : undefined;
}
